export const parseHome = (json) => {
  return {
    id: json.id ?? 0,
    title: json.title ?? "",
    titleBackgroundColor: json.title_background_color,
    titleTextColorLight: json.title_text_color_light,
    titleTextColorDark: json.title_text_color_dark,
    titleAlignment: json.title_alignment,
    bodyText: json.body_text,
    bodyBackgroundColor: json.body_background_color,
    bodyTextColorLight: json.body_text_color_light,
    bodyTextColorDark: json.body_text_color_dark,
    bodyTextAlignment: json.body_text_alignment,
    imageUrl: json.image_url,
    websiteImageUrl: json.website_image_url,
    buttonText: json.button_text,
    buttonLink: json.button_link,
    buttonAlignment: json.button_alignment,
    sortOrder: json.sort_order ?? 0,
    isActive: json.is_active === 1 || json.is_active === true,
    createdAt: json.created_at,
    updatedAt: json.updated_at,
  };
};
